/**
 * External dependencies
 */
import page from "page";
import { createRoot } from "react-dom/client";
/**
 * Internal dependencies
 */
import { isUserLoggedIn } from "state/current-user/selectors";

const root = createRoot(document.getElementById("root"));

export function redirectLoggedOut(context, next) {
  const state = context.store.getState();
  const userLoggedOut = !isUserLoggedIn(state);

  if (userLoggedOut) {
    // force full page reload to avoid SSR hydration issues.
    window.location = "/login";
    return;
  }

  next();
}

export function hydrate(context) {
  root.render(context.layout);
}

export function render(context) {
  //const root = createRoot(document.getElementById("root"));
  root.render(context.layout);
}

export function redirectLoggedIn(context, next) {
  const userLoggedIn = isUserLoggedIn(context.store.getState());

  if (userLoggedIn) {
    page.redirect("/");
    return;
  }

  next();
}
